import { createElement } from '../modules/globalFunctions'

const moveBlogOnHomepage = (blogBlock) => {
	if (!blogBlock) return
	const middleBanners = document.querySelector('.middle-banners-wrapper')
	const blogInner = createElement('div', ['homepage-blog-inner', 'container'])
	blogInner.innerHTML = blogBlock.innerHTML
	blogBlock.innerHTML = ''
	blogBlock.appendChild(blogInner)

	if (middleBanners) middleBanners.after(blogBlock)
}
const moveFirstParagraph = () => {
	const text = document.querySelector('.text')
	const image = document.querySelector('span[itemprop="image"] meta[itemprop="url"]')
	
	const firstParagraph = document.querySelector('.text>p')
	if (!firstParagraph) return
	const headLine = document.querySelector('h1[itemprop="headline"]')
	if(!headLine) return
	const time = document.querySelector("time")
	if(!time) return
	const groupElm = document.createElement('div')
	groupElm.classList.add('blog-group')
	const groupText = document.createElement('div')
	groupText.classList.add('blog-group-text')
	const groupImage = document.createElement('div')
	groupImage.classList.add('blog-group-image')
	const imageElm = document.createElement('img')
	if(image){
		const imageContent = image.getAttribute('content')
		
	imageElm.classList.add('img-fluid')
	imageElm.setAttribute('src', imageContent)
	imageElm.setAttribute('alt', headLine.textContent)
		groupImage.appendChild(imageElm)
	
	}
	
	groupText.appendChild(time)
	if(window.innerWidth < 768) {
		groupImage.appendChild(time)
	}
		groupText.appendChild(headLine)
	groupText.appendChild(firstParagraph)
	

	groupElm.appendChild(groupText)
	groupElm.appendChild(groupImage)

	text.insertAdjacentElement('beforebegin', groupElm)
}
if(document.body.classList.contains('type-post')) {
	moveFirstParagraph()
}
// blog on homepage - changes title and buttons text and creates a new button that leads to the blog page
// add following variables to HTML editor: nadpisBlogHP, odkazNaBlogText, odkazNaBlog
const blogOnHomepage = () => {
	const blogBlock = document.querySelector('.homepage-blog-wrapper')
	if (!blogBlock) return
	setTimeout(() => {	
	addDescription()
	}, 250)

	moveBlogOnHomepage(blogBlock)
	const blogBlockTitle = blogBlock.querySelector('.homepage-group-title')
	const  nadpisBlogHP = "Píšeme pro Vás";
	if (blogBlockTitle && typeof nadpisBlogHP !== 'undefined') blogBlockTitle.textContent = nadpisBlogHP ? nadpisBlogHP : ''
const blogBlockButtonAllText = typeof odkazNaBlogText !== 'undefined'
	? odkazNaBlogText
	: (window.language === 'cs' ? 'Zobrazit všechny články' : 'Zobraziť všetky články');
	const newsBlogInner = document.createElement('div')
			newsBlogInner.classList.add('homepage-item-wrapper')
const blogBlockButtonAll = createElement(
	'a',
	['btn', 'btn-primary', 'btn-all-articles'],
	blogBlockButtonAllText
);

	blogBlockButtonAll.href = typeof odkazNaBlog !== 'undefined' ? odkazNaBlog : '/nase-novinky'
	blogBlock.querySelector(".homepage-blog-inner").appendChild(newsBlogInner)
	blogBlock.querySelector(".homepage-blog-inner").appendChild(blogBlockButtonAll)

			

	const newsItems = blogBlock.querySelectorAll('.news-item')
	if (newsItems.length) {
		newsItems.forEach((newsItem) => {
			newsBlogInner.appendChild(newsItem)

			
			const newsItemButton = newsItem.querySelector('.read-article')
			if (!newsItemButton) return
			newsItemButton.classList.add('btn', 'btn-secondary', 'btn-read-more')
			if (newsItemButton) newsItemButton.textContent = window.language === 'cs' ? 'Číst více' : 'Čítať viac'
		
		})
	}
	
}

const addDescription = async () => {
    const newsItems = document.querySelectorAll('.news-item');
    for (const newsItem of newsItems) {
        const newsItemLink = newsItem.querySelector('a');
        const descBlock = newsItem.querySelector('.description');
        if (newsItemLink && descBlock) {
            try {
                const res = await fetch(newsItemLink.href);
                const html = await res.text();
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const descElm = doc.querySelector('.text>p');
                if (descElm) {
       
                    descBlock.textContent = descElm.textContent;
                }
            } catch (e) {
                console.error('Chyba při načítání textu článku:', e);
            }
        }
    }
};


// creates a link to the article in the text of the news item
const addLinkToArticles = () => {
	const newsItems = document.querySelectorAll('.news-item')
	if (newsItems.length) {
		newsItems.forEach((newsItem) => {
			const newsItemLink = newsItem.querySelector('a.title')
			if (newsItemLink) {
				const addedLink = createElement('a', ['read-article'], window.language === 'cs' ? 'Přečíst článek' : 'Prečítať článok')
				addedLink.href = newsItemLink.href
				const text = newsItem.querySelector('.text')
				if (text) text.appendChild(addedLink)
			}
		})
	}
}
export { blogOnHomepage, addLinkToArticles }
